import React, { useMemo, useState } from 'react'
import fastDeepEqual from 'fast-deep-equal'
import { getLocationFromAddress, ILocation } from './locationHelpers'
import { CustomInputMappingField } from '@tuqqi/common'
import { makeStyles, Theme } from '@material-ui/core'
import { LocationMap } from './LocationMap'
import { LocationTextEdit } from './LocationTextEdit'

const styles = (theme: Theme) => ({
    container: {
        paddingLeft: 0,
        paddingRight: 0,
        width: 'inherit',
        marginTop: -10,
        paddingTop: 0,
    },
    map: {
        transition: 'opacity 0.25s ease-in-out', 
    }
})

const useStyles = makeStyles(styles)


type Props = {
    isRtl: boolean
    field: CustomInputMappingField
    location: ILocation | null
    setLocation: (l: ILocation | null) => void
}

export const InputLocationField = (props: Props) => {
    const geoLocation = props.location?.geoLocation ?? undefined
    const locationAddress = props.location?.locationAddress ?? undefined
    const classes = useStyles()
    const label = props.field.fieldName

    const value: ILocation | null = useMemo(() => {
        if(!locationAddress || !geoLocation) return null
        return {
            geoLocation,
            locationAddress
        }
    }, [locationAddress, geoLocation])

    const [shown, setShown] = useState(!!value)

    const show = () => {
        setShown(true)
    }

    const updateLocation = (location: ILocation | null) => {
        const hasValueChanged = !fastDeepEqual(location, value)
        if(!hasValueChanged) return

        props.setLocation(location)
    }
    const updateLocationFromAddress = async (locationAdress?: string) => {
        const correctAddress = await getLocationFromAddress(locationAdress ?? '')
        const hasValueChanged = !fastDeepEqual(correctAddress, value)
        if(!hasValueChanged) return

        props.setLocation(correctAddress)
    }
    
    const icon = null

    const renderMap = () => {
        if(!shown) return null
        return <div data-intrcm-id="InputLocation_3umz46lh" className={classes.map} >
                <LocationMap isReadOnly={false} updateCurrentLocation={updateLocation} value={value} />
        </div>
    }

    return <div data-intrcm-id="InputLocation_nidcuhmg" className={classes.container}>
        <LocationTextEdit isCustomField isRtl={props.isRtl} setShown={setShown} shown={shown} isNewItem sourceField='' icon={icon} value={value} label={label} description={""} onBlur={updateLocationFromAddress} />
        {renderMap()}
    </div>

}